/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/label-has-associated-control */
import CmsBlock from 'Component/CmsBlock';
import ExpandableContent from 'Component/ExpandableContent';
import Field from 'Component/Field';
import { FIELD_TYPE } from 'Component/Field/Field.config';
import Popup from 'Component/Popup/Popup.container';
import {
    NewsletterSubscription as SourceNewsletterSubscription
} from 'SourceComponent/NewsletterSubscription/NewsletterSubscription.component';
import getStore from 'Util/Store';

import './NewsletterSubscription.override.style';

/** @namespace Elganso/Component/NewsletterSubscription/Component */
export class NewsletterSubscriptionComponent extends SourceNewsletterSubscription {
    handleShowPopup = this.handleShowPopup.bind(this);

    handleShowPopup(e) {
        const { showPopup } = this.props;

        e.preventDefault();
        showPopup();
    }

    renderActions() {
        const { isTACAccepted } = this.props;

        return (
            <button
              type={ FIELD_TYPE.submit }
              block="Button"
              mods={ { isHollow: true } }
              disabled={ !isTACAccepted }
            />
        );
    }

    renderTAC() {
        const { setTACAccepted } = this.props;

        return (
            <div
              block="NewsletterSubscription"
              elem="TermsAndConditions"
            >
                <label
                  block="NewsletterSubscription"
                  elem="TACLabel"
                  htmlFor="termsAndConditions"
                >
                    <Field
                      type={ FIELD_TYPE.checkbox }
                      attr={ {
                          id: 'termsAndConditions',
                          name: 'termsAndConditions',
                          value: 'termsAndConditions'
                      } }
                      events={ {
                          onChange: setTACAccepted
                      } }
                      mix={ { block: 'NewsletterSubscription', elem: 'TermsAndConditions-Checkbox' } }
                    />
                   <div block="Text">
                        { __('I agree to terms and conditions') }
                   </div>
                </label>
            </div>
        );
    }

    renderPopupTAC() {
        const { blockPopupConditionsPopup, isTACAccepted } = this.props;
        const privacidadNewsletter = 'privacidadnewsletter';

        if (blockPopupConditionsPopup) {
            return (
                <ExpandableContent
                  heading={ __('Show terms and conditions') }
                  isArrow
                  isContentExpanded={ isTACAccepted }
                  mix={ { block: 'NewsletterSubscription', elem: 'ExpandableContent' } }
                >
                    <CmsBlock identifier={ privacidadNewsletter } />
                </ExpandableContent>
            );
        }

        return (
            <Popup
              id="newsletter_popup"
              clickOutside={ false }
              mix={ { block: 'Newsletter', elem: 'Popup' } }
            >
                <CmsBlock identifier={ privacidadNewsletter } />
            </Popup>
        );
    }

    renderPopupSubscribe() {
        return (
            <Popup
              id="newsletter_subscribe"
              clickOutside={ false }
              mix={ { block: 'Newsletter', elem: 'Popup' } }
            >
                <div className="newsletter_suscripcion">

                <h1 className="title_newsletter_suscripcion">{ __('¡Gracias por suscribirte!') }</h1>
                <div className="body_newsletter_suscripcion">{ __('A partir de ahora serás el primero en enterarte de todas nuestras promociones y novedades.') }</div>
                <div className="footer_newsletter_suscripcion">EL GANSO</div>

                </div>
            </Popup>
        );
    }

    renderCategories() {
        const {
            catHombre, catMujer, catZapas, catNino, catAccesorios, onCategoriesClick
        } = this.props;

        return (
            <div
              block="NewsletterSubscription"
              elem="CategoriesForm"
            >
                <label
                  block="NewsletterSubscription"
                  elem="Label"
                  htmlFor="catHombre"
                >
                    <Field
                      type={ FIELD_TYPE.checkbox }
                      attr={ {
                          id: 'catHombre',
                          name: 'catHombre',
                          checked: catHombre
                      } }
                      events={ {
                          onChange: onCategoriesClick
                      } }
                      mix={ { block: 'NewsletterSubscription', elem: 'Checkbox' } }
                    />
                    <div block="Text">
                        Hombre
                    </div>
                </label>
                <label
                  block="NewsletterSubscription"
                  elem="Label"
                  htmlFor="catMujer"
                >
                    <Field
                      type={ FIELD_TYPE.checkbox }
                      attr={ {
                          id: 'catMujer',
                          name: 'catMujer',
                          checked: catMujer
                      } }
                      events={ {
                          onChange: onCategoriesClick
                      } }
                      mix={ { block: 'NewsletterSubscription', elem: 'Checkbox' } }
                    />
                   <div block="Text">
                        Mujer
                   </div>
                </label>
                <label
                  block="NewsletterSubscription"
                  elem="Label"
                  htmlFor="catZapas"
                >
                    <Field
                      type={ FIELD_TYPE.checkbox }
                      attr={ {
                          id: 'catZapas',
                          name: 'catZapas',
                          checked: catZapas
                      } }
                      events={ {
                          onChange: onCategoriesClick
                      } }
                      mix={ { block: 'NewsletterSubscription', elem: 'Checkbox' } }
                    />
                   <div block="Text">
                        Zapatillas
                   </div>
                </label>
                <label
                  block="NewsletterSubscription"
                  elem="Label"
                  htmlFor="catNino"
                >
                    <Field
                      type={ FIELD_TYPE.checkbox }
                      attr={ {
                          id: 'catNino',
                          name: 'catNino',
                          checked: catNino
                      } }
                      events={ {
                          onChange: onCategoriesClick
                      } }
                      mix={ { block: 'NewsletterSubscription', elem: 'Checkbox' } }
                    />
                   <div block="Text">
                        Niño
                   </div>
                </label>
                <label
                  block="NewsletterSubscription"
                  elem="Label"
                  htmlFor="catAccesorios"
                >
                    <Field
                      type={ FIELD_TYPE.checkbox }
                      attr={ {
                          id: 'catAccesorios',
                          name: 'catAccesorios',
                          checked: catAccesorios
                      } }
                      events={ {
                          onChange: onCategoriesClick
                      } }
                      mix={ { block: 'NewsletterSubscription', elem: 'Checkbox' } }
                    />
                   <div block="Text">
                        Accesorios
                   </div>
                </label>
            </div>
        );
    }

    render() {
        const { showCategories } = this.props;

        const {
            crear_bono_newsletter
        } = getStore().getState().ConfigReducer;

        return (
            <div block="NewsletterSubscription">
                <div block="NewsletterSubscription" elem="title">
                    { __('Newsletter') }
                </div>
                <div block="NewsletterSubscription" elem="body">
                    <div block="NewsletterSubscription" elem="info">
                        { __("Don't miss anything. Subscribe to our newsletter") }
                        { crear_bono_newsletter ? (
                            <div>{ __('Suscríbete ahora y consigue 10€ de descuento en tu primera compra.') }</div>
                        ) : null }

                    </div>
                    { super.render() }
                    { showCategories
                        ? (
                            <div block="NewsletterSubscription" elem="Categories">
                                <p className="textCategories">
                                    Selecciona las categorías que más te interesan para recibir novedades y promociones:
                                </p>
                                { this.renderCategories() }
                            </div>
                        )
                        : null }
                    <div block="NewsletterSubscription" elem="Terms">
                        { this.renderTAC() }
                    </div>
                </div>
                { this.renderPopupTAC() }
                { this.renderPopupSubscribe() }
            </div>
        );
    }
}

export default NewsletterSubscriptionComponent;
